import { getter } from './store';

export const getUploadQueueLength = getter('GET_UPLOAD_QUEUE_LENGH', (state) => state.uploadData.length)
export const getUploadQueue = getter('GET_UPLOAD_QUEUE', (state) => state.uploadData)


